import * as React from 'react';

import { cn } from '@/_shared/lib/utils';

import euFlagUrl from './eu.svg';
import inFlagUrl from './in.svg';
import usFlagUrl from './us.svg';

/**
 * Circular region flags for the RudderStack data-plane regions we can flag. The brand flag colors are
 * baked into the SVG assets (imported as URLs, rendered through a decorative `<img>`) — the same
 * intentional exception to the no-hardcoded-color rule as WarehouseTypeIcon. `EU` is a combined
 * EU + UK mark, since the UK is served by the EU region but isn't part of the EU. Any other region
 * value renders no flag (the caller still shows the region text).
 */
const REGION_FLAG_URLS: Record<string, string> = {
  US: usFlagUrl,
  EU: euFlagUrl,
  IN: inFlagUrl,
};

export function RegionFlag({ region, className }: { region: string; className?: string }): React.ReactElement | null {
  const src = REGION_FLAG_URLS[region.toUpperCase()];
  if (!src) return null;
  return <img src={src} alt="" aria-hidden className={cn('size-3 shrink-0', className)} />;
}
